'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.resolveAttachments = undefined;

var _createDeprecatedAsyncAction = require('conversations-async-data/async-action/createDeprecatedAsyncAction');

var _resolveAttachmentsClient = require('../clients/resolveAttachmentsClient');

var _resolvedAttachmentsActionTypes = require('../constants/resolvedAttachmentsActionTypes');

var _buildResolvedAttachmentsMapFromResponse = require('../operators/buildResolvedAttachmentsMapFromResponse');

var resolveAttachments = exports.resolveAttachments = (0, _createDeprecatedAsyncAction.createDeprecatedAsyncAction)({
  requestFn: _resolveAttachmentsClient.resolveAttachmentsClient,
  actionTypes: _resolvedAttachmentsActionTypes.RESOLVE_ATTACHMENTS,
  toRecordFn: _buildResolvedAttachmentsMapFromResponse.buildResolvedAttachmentsMapFromResponse
});